import React, { useEffect, useState, useMemo } from "react";

import { IonContent, IonButton, IonIcon } from "@ionic/react";
import Order from "./order";
import { Empty, Skeleton, Row } from "antd";

const OrderList = ({ is_loading_orders, orders_filtered, selected_order_id, onSelect, css, isReport }) => {
  const getAllOrderTotal = () => {
    let total = 0;
    for (let order of orders_filtered) {
      total += getOrderTotal(order);
    }
    return total;
  };

  const getOrderTotal = (order) => {
    if (order == null) {
      return 0;
    }
    let total = 0;
    for (let i of order.items) {
      total += getItemTotal(i);
    }
    return total;
  };

  const getItemTotal = (item) => {
    let singleItemPrice = item.drink == null ? item.price : item.price + item.drink.price;
    return singleItemPrice * item.qty;
  };

  useEffect(() => {
    // console.log(orders_filtered);
  }, [is_loading_orders, orders_filtered]);

  return (
    <IonContent className="custom-scrollbar" style={{ ...css, border: "3px solid #F1F1F1" }}>
      {is_loading_orders ? (
        isReport ? (
          <>
            <Row justify="end" style={{ margin: 15 }}>
              <Skeleton.Button active style={{ height: 25, borderRadius: 15 }} />
            </Row>
            <Row style={{ margin: 15 }}>
              <Skeleton.Button active style={{ height: 50, borderRadius: 15 }} block />
            </Row>
          </>
        ) : (
          <>
            <Row style={{ margin: 15 }}>
              <Skeleton.Button active style={{ height: 100, borderRadius: 15 }} block />
            </Row>
          </>
        )
      ) : orders_filtered.length > 0 ? (
        <Row>
          {isReport ? (
            <Row justify="end" align="middle" style={{ width: "100%", fontSize: 20, marginTop: 10, marginRight: 15 }}>
              總額 ${getAllOrderTotal()}
            </Row>
          ) : null}
          {orders_filtered.map((e, i) => (
            <Order
              key={i}
              order={e}
              selected_order_id={selected_order_id}
              onSelect={(orderId) => {
                onSelect(orderId);
              }}
              isReport={isReport}
            />
          ))}
        </Row>
      ) : (
        <Empty
          style={{ fontSize: 24, position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}
          description="暫無訂單"
        />
      )}
    </IonContent>
  );
};

export default OrderList;
